import React, { useMemo } from "react";
import "./ContainerType.scss";
import { containerSizeStringToNumber } from "../../utils/general";

interface ContainerTypeProps {
  size: number | string;
  type: string;
}

const ContainerType: React.FC<ContainerTypeProps> = React.memo(
  ({ size, type }) => {
    const { label, backgroundColor, textColor, borderColor } = useMemo(() => {
      // Convert size to number if it's a string, default to 0 if null
      const sizeNumber =
        typeof size === "string"
          ? containerSizeStringToNumber(size) ?? 0
          : size;

      const sizeStyles: Record<
        number,
        { backgroundColor: string; textColor: string; borderColor: string }
      > = {
        20: {
          backgroundColor: "rgba(29, 53, 87, 0.10)",
          textColor: "#1D3557",
          borderColor: "#1D3557",
        },
        40: {
          backgroundColor: "rgba(69, 123, 157, 0.10)",
          textColor: "#1062b9",
          borderColor: "#1062b9",
        },
        45: {
          backgroundColor: "rgba(105, 185, 188, 0.10)",
          textColor: "#69B9BC",
          borderColor: "#69B9BC",
        },
      };

      return {
        label: `${sizeNumber} ${type}`,
        ...(sizeStyles[sizeNumber] || {
          backgroundColor: "rgba(69, 123, 157, 0.10)",
          textColor: "#838285",
          borderColor: "#1062b9",
        }),
      };
    }, [size, type]);

    return (
      <span
        className="container-type"
        style={{
          border: `1px solid ${borderColor}`,
          backgroundColor,
          color: textColor,
          padding: "4px 12px",
          borderRadius: "3px",
          fontWeight: "600",
          fontSize: "14px",
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          width: "50px",
          justifyContent: "center",
        }}
      >
        {label}
      </span>
    );
  }
);

export default ContainerType;
